import ShelfItems from "./ShelfItems";
var Shelf = function (shelfContainer) {
    var listSliderContainer = document.createElement("div");
    listSliderContainer.className = "list-slider-container";
    var setElement = ShelfItems(shelfContainer.set);
    listSliderContainer.appendChild(setElement);
    return listSliderContainer;
};
export default Shelf;
